import React, { useEffect, useState } from 'react';
import { useData } from '../../../hooks/useData';
import { useToast } from '../../../hooks/useToast';
import Swal from 'sweetalert2';
import Pagination from '../../../hooks/Pagination';
import { usersManagementServices } from '../../../APIServices/usersManagementServices';

function DeletedUserHistory({
  getUserData,
  setModalOpen,
  deletedPageNumber,
  setDeletedPageNumber,
  deletedItemsPerPage,
  setDeletedItemsPerPage,
  setDeleteUserList,
  deleteUserList,
  setDeleteUserCount,
  deleteUserCount,
  getDeletedUserData,
  title
}) {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [user, setUser] = useState("");

  const startIndex = (deletedPageNumber - 1) * deletedItemsPerPage;
  const totalPage = Math.ceil(deleteUserCount / deletedItemsPerPage);

  const softDeleteRestoreUser = async (userId) => {
    setButtonLoader(false);
    let userDatas = {};
    userDatas.userId = userId;
    userDatas.type = "restore";
    let data = await usersManagementServices.softDeleteRestoreUser(
      userDatas
    );
    if (data?.statusCode === 200) {
      getUserData();
      getDeletedUserData();
      setModalOpen("");
    }
    setButtonLoader(true);
  }

  useEffect(() => {
    getDeletedUserData();
  }, [deletedPageNumber, deletedItemsPerPage]);

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Deleted {title} List
            </div>

            <div className="xs muted">
              Restore and Permanent {title} Delete
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <table className="tbl">
            <thead>
              <tr>
                <th>User</th>
                <th style={{ width: 120 }}>
                  Restore
                </th>
              </tr>
            </thead>
            <tbody>
              {deleteUserList.map((item) => (
                <tr key={item.id}>
                  <td className="medium">
                    {[item.firstName, item.middleName, item.lastName]
                        .filter(Boolean)
                        .join(" ")}
                  </td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="icon-btn"
                        title="Restore"
                        style={{
                          color:
                            'var(--info)',
                        }}
                        onClick={() => softDeleteRestoreUser(item?.userId)}
                      >
                        <i className="ti ti-rotate" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            itemsPerPage={deletedItemsPerPage}
            setItemsPerPage={setDeletedItemsPerPage}
            pageNumber={deletedPageNumber}
            setPageNumber={setDeletedPageNumber}
            totalPage={totalPage}
            totalItems={deleteUserCount}
          />
        </div>
      </div>
    </div>
  );
}

export default DeletedUserHistory;